<template>
  <div>
    <HeaderComponent :menu-id="2"></HeaderComponent>
    <div style="background-color: #FFFAF4;">
      <div class="peifu-container" style="padding-bottom: 0px;">
        <!-- 标题 -->
        <div class="title-ty" style="padding-bottom: 50px;">
          <div class="title-ty-y">SHUISHI GRADING</div>
          <div class="title-ty-z"><span>古钱币送评</span>赔付标准</div>
        </div>
        <div class="peifu-box" style="padding-bottom: 0px;">
          <div class="tixing"><span>特别提醒:</span> 您一经选择水石评级的服务，即视为接受本承诺全部条款，若您不接受本
承诺全部或部分条款，请及时向我们作出说明。</div>
          <p class="p-ty">1.水石评级对送评古钱币"一币一估值，全额赔付”，若经水石评级评级过的钱币，经复评后确认为伪品或修补品，水石评级将按
照该枚钱币估值全额赔付。机制币赔付标准，不按照"一币一估值，全额赔付”，详见对应网页。
客户索赔时，需要将评级盒或评级证书与币一同返还水石评级进行复核。如将该币评级盒或证书遗弃，视同服务终止，无法提供
赔偿服务。</p>
          <p class="p-ty">2.评级信息中的估值，是送评时市场价值的评估，并以此作为水石评级的收费和赔付的标准。估值是依据送评人送评时的市场价
值进行标注，如若行情上涨，评级币持有人认为钱币价格超出估值对应的钱币价值范围，可将评级币寄回公司申请提升估值，经公司复评确认后，并补齐评级费差价。赔付将依据新的估值对应的钱币承担赔付责任。当市场行情下降，评级币持有人也可以申
请降档。</p>
          <p class="p-ty">3.因开放式封装盒可以反复开启，若送评人接收钱币并确认无误后，出现非水石评级方原因，导致的送评钱币外观、内部等发生
变化的，水石评级不承担由此造成的损失。</p>
          <p class="p-ty">4.在收到送评钱币后，送评人需检查所有钱币，在收到钱币后3个工作日内，送评人可就钱币的毁损、差异、瑕疵等向客服反
馈，否则水石评级概不对损坏、差异、瑕疵等承担任何责任。若送评钱币"漏裂问题"未予标注的，按照三倍评级费进行赔付。</p>
          <p class="p-ty">5.若钱币评级过程中发生遗失、损坏的情况，水石评级将按该钱币当前市场价值进行赔付。如在邮寄过程中如发生丢失或损坏，赔付责任由运输公司承担，水石评级将积极配合客户的索赔工作。强烈建议客户在邮寄过程中进行保价，否则造成的一切责任及损失由币主自行承担。水石评级所邮寄钱币，均进行保价，保价费用由客户承担。保价邮件丢失或损坏，一律按保价金额或相关条款向寄送公司索赔，水石评级不负赔偿责任，但尽力协调客户与快递公司。如因客户未提出保价，造成邮寄中的损失，责任由币主和快递单位自行解决，水石评级配合协调处理。</p>
          <p class="p-ty">6.对于估值1000元以下的钱币，按水石评级估值赔付.但不超出对应的最高赔付上限(上限为1000元)。</p>
          <p class="p-ty">7.关于"真品"评级，按客户特殊要求对其钱币仅进行真伪鉴定进行封装的，水石评级仅对其真伪负责，不进行估值和定额赔付。</p>
          <p class="p-ty">8.本承诺的最终解释权归水石评级所有。</p>
        </div>

      </div>
    </div>
    <!-- <div>
      <div class="peifu-box">
        <div class="tixing">不适用于上述赔付条款的情况如下:</div>
        <p class="p-ty">1.由于钱币行情原因其价值发生变化而引起的赔付。</p>
        <p class="p-ty">2.因环境影响储存不当或人为造成的损伤(原钱币以装盒二维码图片资料为准)。</p>
        <p class="p-ty">3.钱币评级盒或证书上由于输入错误，出现明显的文字错误，如评级盒上显示的直径、厚度、年代或名称与实物不符，与钱币评
级有关的极为明显的录入或印刷错误。</p>
      </div>
    </div> -->
    <img src="@/assets/image/peifu-guqian.jpg" alt="" style="width: 100%;">
    <FooterComponent></FooterComponent>
  </div>
</template>

<script>
import HeaderComponent from '@/components/HeaderComponent.vue'
import FooterComponent from '@/components/FooterComponent.vue'

export default {
  data() {
    return {
    }
  },
  methods: {
  },
  components: {
    HeaderComponent,
    FooterComponent
  },
  created() {
  },
}
</script>
<style lang="less" scoped>

</style>